/* Price range slider for collection pages. */
(function () {
    var box = document.querySelector('[data-be-price]');
    if (!box) { return; }
    var minP = box.getAttribute('data-min-param'), maxP = box.getAttribute('data-max-param');
    var top = Math.ceil((parseInt(box.getAttribute('data-range-max'), 10) || 0) / 100 / 100) * 100;
    if (top < 100) { top = 100; }
    var lo = box.querySelector('[data-lo]'), hi = box.querySelector('[data-hi]');
    var loN = box.querySelector('[data-lo-n]'), hiN = box.querySelector('[data-hi-n]');
    var fill = box.querySelector('[data-fill]');
    /* Slider runs 0-1000; prices follow a curve so cheaper ranges get more room. */
    var N = 1000;
    var nice = function (v) { var s = v < 500 ? 10 : v < 2000 ? 50 : v < 10000 ? 100 : 500; return Math.round(v / s) * s; };
    var toVal = function (p) { return p >= N ? top : nice(top * Math.pow(p / N, 2.5)); };
    var toPos = function (v) { return Math.round(N * Math.pow(Math.min(Math.max(v, 0), top) / top, 1 / 2.5)); };
    [lo, hi].forEach(function (r) { r.max = N; r.step = 1; });
    loN.max = top; hiN.max = top;
    var params = new URLSearchParams(window.location.search);
    var curLo = parseFloat(params.get(minP)), curHi = parseFloat(params.get(maxP));
    var a0 = isNaN(curLo) ? 0 : curLo, b0 = isNaN(curHi) ? top : curHi;
    lo.value = toPos(a0); hi.value = toPos(b0);
    var paint = function () {
      fill.style.left = (lo.value / N * 100) + '%';
      fill.style.width = ((hi.value - lo.value) / N * 100) + '%';
    };
    loN.value = a0; hiN.value = b0; paint();
    var syncNums = function () { loN.value = toVal(+lo.value); hiN.value = toVal(+hi.value); paint(); };
    lo.addEventListener('input', function () { if (+lo.value > +hi.value - 5) { lo.value = +hi.value - 5; } syncNums(); });
    hi.addEventListener('input', function () { if (+hi.value < +lo.value + 5) { hi.value = +lo.value + 5; } syncNums(); });
    var apply = function () {
      var a = Math.max(0, parseFloat(loN.value) || 0);
      var b = parseFloat(hiN.value);
      if (isNaN(b) || b > top) { b = top; }
      if (b < a) { var t = a; a = b; b = t; }
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (a > 0) { url.searchParams.set(minP, a); } else { url.searchParams.delete(minP); }
      if (b < top) { url.searchParams.set(maxP, b); } else { url.searchParams.delete(maxP); }
      window.location.href = url.toString();
    };
    /* Apply shortly after the customer lets go, so both handles can be moved first. */
    var timer = null;
    var later = function () { clearTimeout(timer); timer = setTimeout(apply, 1200); };
    lo.addEventListener('change', later);
    hi.addEventListener('change', later);
    [lo, hi].forEach(function (r) { r.addEventListener('pointerdown', function () { clearTimeout(timer); }); });
    box.querySelector('[data-apply]').addEventListener('click', apply);
    [loN, hiN].forEach(function (n) {
      n.addEventListener('input', function () { lo.value = toPos(+loN.value || 0); hi.value = toPos(hiN.value === '' ? top : +hiN.value); paint(); });
      n.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
    });
})();
